import Vue from 'vue'

import { 
    Button,
    NavBar,
    Toast,
    Icon,
    IndexBar, 
    IndexAnchor,
    Swipe, 
    SwipeItem, 
    Lazyload, 
    Image ,
    Area,
    Popup,
    Dialog,
    List,
    Tab,
    Tabs,
    Loading,
    Overlay,
    Cell,
    Field,
    Picker,
    DatetimePicker,
    PullRefresh,
    Skeleton,
    RadioGroup, Radio, Switch,SwipeCell,Checkbox, CheckboxGroup,Stepper,
    CountDown ,
    Row, Col,
    Progress,
    Divider,
    Empty,
    Tag,Grid, GridItem,Search,Sticky
} from 'vant';
import Calendar from '@/components/calendar'
import ProgressJhd from '@/components/progress-jhd'

Vue.prototype.$Toast = Toast;

Vue.use(List);
Vue.use(Cell);
Vue.use(Dialog);
Vue.use(Popup);
Vue.use(Area);
Vue.use(Toast);
Vue.use(Button);
Vue.use(NavBar);
Vue.use(Icon);
Vue.use(IndexBar);
Vue.use(IndexAnchor);
Vue.use(Tab).use(Tabs);
Vue.use(Swipe).use(SwipeItem).use(Lazyload).use(Image).use(Loading).use(Overlay).use(RadioGroup).use(Radio).use(Switch).use(Field).use(Picker).use(DatetimePicker).use(PullRefresh).use(Stepper).use(Skeleton);
Vue.use(SwipeCell);
Vue.use(Checkbox).use(CheckboxGroup);
Vue.use(CountDown);
Vue.use(Row);
Vue.use(Col);
Vue.use(Progress).use(ProgressJhd)
Vue.use(Divider)
Vue.use(Empty)
Vue.use(Tag).use(Grid).use(GridItem).use(Search).use(Calendar).use(Sticky)